module.exports = __webpack_public_path__ + "media/images/paysera-partner-5e4128f2.svg";